import { Component, Input } from '@angular/core';
import { Sizes, ThemePalette } from '@platform500services/p500-ui-kit/buttons/buttons.interfaces';
import { ActionButtonComponent } from './action-button.component';

@Component({
  selector: 'gtd-process-button',
  templateUrl: './process-button.component.html',
})
export class ProcessButtonComponent extends ActionButtonComponent {
  @Input() title: string;
  @Input() stroked: boolean;
  @Input() classIcon: string;
  @Input() positionIcon: 'left' | 'right';
  @Input() size: Sizes;
  @Input() color: ThemePalette;
}
